import React, { useState } from 'react';
import {
  Box,
  Center,
  Flex,
  Image,
  Text,
  VStack,
  Button,
  Grid,
  GridItem,
} from '@chakra-ui/react';
import CourseSkeleton from '../Sketelen/CourseSkeleton';
import { useEffect } from 'react';
import { useDispatch, useSelector } from "react-redux"
import { getCourse } from '../Redux/Course/action';
import { Link } from 'react-router-dom';
const categories = [
  'Categories',
  'Programming',
  'Business & Management',
  'Core Engineering',
  'Data Science',
  'Design',
  'Creative Arts',
  'Career Development',
];



const Course = () => {
 const store = useSelector((state) => state.CourseReducer)
 const dispatch = useDispatch()
 useEffect(() => {
     dispatch(getCourse)
 },[])
  if(store.isloading){
    return <CourseSkeleton/>
  }
  console.log(store.c)
  return (
    <Box>
      <Flex mb={"20px"} mt={"100px"} p={4}>
        {/* Sidebar */}
        <Box w="300px" pr={4}>
          <VStack ml={5} align="start" spacing={2}>
            {categories.map((category, index) => (
              <Center key={category._id}>
                <Text
                  w={"100%"}
                  fontWeight={index === 0 ? 'bold' : 'normal'}
                  p={4}
                  color={index === 0 ? 'blue.600' : 'black'}
                  _hover={{
                    bgColor: index === 0 ? 'transparent' : 'blue.100',
                    color: index === 0 ? 'blue.600' : 'blue.600',
                    cursor: 'pointer',
                  }}
                >
                  {category}
                </Text>
              </Center>
            ))}
          </VStack>
        </Box>

        {/* Right Section */}
        <Box flex="1" bg="gray.100" p={4}>
          <Grid templateColumns={{ base: '1fr', md: 'repeat(3, 1fr)' }} gap={6}>
            {store?.course?.map((course, index) => (
              <GridItem key={index}>
                <Box
                  bg="white"
                  borderRadius="md"
                  boxShadow="md"
                  p={4}
                  transition="transform 0.2s, box-shadow 0.2s"
                  _hover={{
                    transform: 'scale(1.03)',
                    boxShadow: 'xl',
                  }}
                >
                  <Image src={course.image} alt="Course" />
                  <Text mt={2} fontWeight="bold">
                    {course.title}
                  </Text>
                  <Text>Fees: {course.price}</Text>
                  <Text mb={1}>Rating: {course.rating}</Text>
                   <Link to={`/course/${course._id}`}>
                   <Button mt={4} mr={4} colorScheme="blue" size="sm">
                    Know More
                  </Button>
                   </Link>
                  <Button mt={4} colorScheme="blue" size="sm">
                    Enroll Now
                  </Button>
                </Box>
              </GridItem>
            ))}
          </Grid>
        </Box>
      </Flex>
    </Box>
  );
};

export default Course;
